"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkTimer = void 0;
class BenchmarkTimer {
    current;
    last;
    cumulative;
    actuallyDoIt;
    first_start;
    constructor(actuallyDoIt) {
        this.actuallyDoIt = actuallyDoIt;
        this.current = null;
        this.last = null;
        this.cumulative = {};
        this.first_start = null;
    }
    Reset() {
        this.current = null;
        this.last = null;
        this.cumulative = {};
        this.first_start = null;
    }
    StartBlock(lblID) {
        if (!this.actuallyDoIt) {
            return;
        }
        if (!this.first_start) {
            this.first_start = performance.now();
        }
        if (this.current == lblID) {
            return;
        }
        this.EndBlock();
        this.current = lblID;
        this.last = performance.now();
    }
    EndBlock() {
        if (!this.actuallyDoIt) {
            return 0;
        }
        let blockTime = 0;
        if (this.current && this.last) {
            const total = this.cumulative[this.current] ?? 0;
            blockTime = Math.round(performance.now() - this.last);
            this.cumulative[this.current] = total + blockTime;
        }
        this.current = null;
        this.last = null;
        return blockTime;
    }
    ShowResults() {
        if (!this.actuallyDoIt) {
            return;
        }
        console.log(this.cumulative);
        if (this.first_start) {
            const total = Math.floor(Math.round(performance.now() - this.first_start));
            console.log(`Total time: ${total}ms`);
        }
    }
}
exports.BenchmarkTimer = BenchmarkTimer;
//# sourceMappingURL=benchmark.js.map